// PE Digital Networks — Placetel Bestellformular Extra JS
(function() {

  // IBAN Formatierung
  window.peFormatIBAN = function(input) {
    var v = input.value.replace(/[^A-Z0-9]/gi,'').toUpperCase();
    var c = v.match(/.{1,4}/g);
    input.value = c ? c.join(' ') : v;
  };

  // Bankverbindung validieren und zu Phase 5
  window.peBankWeiter = function() {
    var k = (document.getElementById('pe-kontoinhaber')||{}).value||'';
    var i = (document.getElementById('pe-iban')||{}).value||'';
    var s = document.getElementById('pe-check-sepa');
    if (!k.trim()) { alert('Bitte Kontoinhaber eingeben.'); return; }
    if (i.replace(/\s/g,'').length < 15) { alert('Bitte IBAN eingeben.'); return; }
    if (!s || !s.checked) { alert('Bitte SEPA-Hinweis bestätigen.'); return; }
    if (typeof peBuildSummary === 'function') peBuildSummary();
    peBuildKosten();
    if (typeof peGoTo === 'function') peGoTo(6);
  };

  // Kostenrechnung
  window.peBuildKosten = function() {
    var state = window.peState || {};
    var t = state.selectedTarif || {};
    var n = parseInt((document.getElementById('pe-nutzer')||{}).value) || 1;
    var p = parseFloat((t.price||'0').toString().replace(',','.').replace(/[^0-9.]/g,'')) || 0;
    var tl = (t.title||'').toLowerCase();
    var einmalig = tl.indexOf('kauf') > -1 || tl.indexOf('einmalig') > -1;
    var addonPrice = (state.addons || []).reduce(function(sum,a) { return sum + (parseFloat(String(a.price).replace(',', '.').replace(/[^0-9.]/g,'')) || 0); }, 0);
    var m = einmalig ? 0 : (p + addonPrice) * n;
    var e = einmalig ? p : 0;
    var body = '';
    if (einmalig) {
      body = '<div style="display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #e2e8f0"><span>' + (t.title||'') + '</span><span><b>' + p.toFixed(2) + ' EUR einmalig (netto)</b></span></div>';
    } else {
      body = '<div style="display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #e2e8f0"><span>' + (t.title||'') + ' x ' + n + ' Nutzer</span><span><b>' + m.toFixed(2) + ' EUR/Mo (netto)</b></span></div>';
    }
    (state.addons || []).forEach(function(a) { var row = document.createElement('div'); row.textContent = a.title + ' × ' + n + ' Nutzer: ' + a.price + ' je Nutzer'; body += row.outerHTML; });
    if (m > 0) body += '<div style="display:flex;justify-content:space-between;padding:4px 0;color:#94a3b8"><span>zzgl. 19% MwSt.</span><span>' + (m*0.19).toFixed(2) + ' EUR/Mo</span></div>';
    if (e > 0) body += '<div style="display:flex;justify-content:space-between;padding:4px 0;color:#94a3b8"><span>zzgl. 19% MwSt.</span><span>' + (e*0.19).toFixed(2) + ' EUR</span></div>';
    if ((state.hardware || []).length) body += '<div>Gewählte Hardware wird in der Bestellprüfung gesondert kalkuliert.</div>';
    var sum = '';
    if (m > 0) sum = 'Monatlich (brutto): <b>' + (m + m*0.19).toFixed(2) + ' EUR</b>';
    if (e > 0) sum += (sum ? ' | ' : '') + 'Einmalig (brutto): <b>' + (e + e*0.19).toFixed(2) + ' EUR</b>';
    var kb = document.getElementById('pe-kosten-body');
    var ks = document.getElementById('pe-kosten-summe');
    if (kb) kb.innerHTML = body;
    if (ks) ks.innerHTML = sum || 'Preis auf Anfrage';
  };

  // PDF Drucken
  window.pePrintSummary = function() {
    if (typeof peBuildSummary === 'function') peBuildSummary();
    peBuildKosten();
    var state = window.peState || {};
    var kb = (document.getElementById('pe-kosten-body')||{}).innerHTML || '';
    var ks = (document.getElementById('pe-kosten-summe')||{}).innerHTML || '';
    var sm = (document.getElementById('pe-summary')||{}).innerHTML || '';
    var dat = new Date().toLocaleDateString('de-DE', {day:'2-digit',month:'2-digit',year:'numeric'});
    var ticket = state.ticketNr || 'PE-XXXX';
    var wrap = document.getElementById('pe-placetel-form-wrap');
    var prodTitle = wrap ? (wrap.dataset.productTitle || 'Placetel') : 'Placetel';

    var html = [];
    html.push('<!DOCTYPE html><html><head><meta charset="utf-8">');
    html.push('<title>Bestellzusammenfassung ' + ticket + '</title>');
    html.push('<style>');
    html.push('body{font-family:Arial,sans-serif;max-width:780px;margin:30px auto;color:#1e293b;font-size:13px}');
    html.push('h1{color:#1e3a5f;font-size:17px;margin-bottom:2px}');
    html.push('.sub{font-size:11px;color:#64748b;margin-bottom:16px}');
    html.push('h2{font-size:13px;border-bottom:2px solid #e2e8f0;padding-bottom:5px;margin-top:18px}');
    html.push('.box{background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:14px}');
    html.push('.summe{background:#1e3a5f;color:#fff;padding:10px 14px;border-radius:6px;font-size:14px;margin-top:8px}');
    html.push('.info{background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:12px;font-size:11px;color:#1e40af;margin-top:16px}');
    html.push('.foot{margin-top:28px;font-size:10px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:10px}');
    html.push('</style></head><body>');
    html.push('<h1>PE Digital Networks &mdash; Bestellzusammenfassung</h1>');
    html.push('<p class="sub">www.premium-electronics.eu | Autorisierter Placetel Reseller</p>');
    html.push('<p><b>Ticket:</b> ' + ticket + ' | <b>Datum:</b> ' + dat + ' | <b>Produkt:</b> ' + prodTitle + '</p>');
    html.push('<h2>Kostenzusammenfassung</h2>');
    html.push('<div class="box">' + kb + '<div class="summe">' + ks + '</div></div>');
    html.push('<h2>Bestelldetails</h2>');
    html.push('<div>' + sm + '</div>');
    html.push('<div class="info">Das SEPA-Lastschriftmandat erhalten Sie direkt von Placetel GmbH &amp; Co. KG zur Unterzeichnung zugesandt. Diese Zusammenfassung ist kein Vertrag.</div>');
    html.push('<div class="foot">PE Digital Networks | www.premium-electronics.eu | info@premium-electronics.eu | Autorisierter Placetel Reseller</div>');
    html.push('</body></html>');

    var w = window.open('', '_blank', 'width=860,height=700');
    if (w) {
      w.document.open();
      w.document.write(html.join(''));
      w.document.close();
      setTimeout(function(){ w.print(); }, 800);
    }
  };

})();
